import React from "react";
import { SelectBox } from "devextreme-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubGridApiDefault } from "../../../../config/fetchApiConfig";
import { SET_ALARMCONNECTION_EDIT } from "./../../../../redux/actions/actionTypes";

const AccountFieldSelectBox = ({ setValue, value }) => {
  const [customValue, setCustomValue] = React.useState(null);
  const dispatch = useDispatch();
  const alarmConnectiontate = useSelector((p) => p.AlarmConnectionReducer);

  useEffect(() => {
    if (value) {
      dispatch({
        type: SET_ALARMCONNECTION_EDIT,
        payload: { dataField: "selectedAccountFieldId", value: value },
      });
      setCustomValue(value);
    }
  }, [value]);

  return (
    <SelectBox
      dataSource={setSubGridApiDefault(
        "AccountView",
        "id",
        "GetListAccountField",
        null,
        null,
        null,
        { accountId: alarmConnectiontate.selectedAccountId }
      )}
      displayExpr="value"
      onValueChanged={({ value }) => {
        setValue && setValue(value.id);
        setCustomValue(value.id);
        dispatch({
          type: SET_ALARMCONNECTION_EDIT,
          payload: { dataField: "selectedSbomId", value: null },
        });
        dispatch({
          type: SET_ALARMCONNECTION_EDIT,
          payload: { dataField: "selectedCentralId", value: null },
        });
        dispatch({
          type: SET_ALARMCONNECTION_EDIT,
          payload: { dataField: "selectedAccountFieldId", value: value.id },
        });
      }}
      searchEnabled={true}
      value={customValue ?? alarmConnectiontate.selectedAccountFieldId}
      placeholder="Lütfen saha seçiniz"
    />
  );
};
export default AccountFieldSelectBox;
